export default __webpack_public_path__ + "static/Icebar-square-texture-7a20deaf907e0e415862037c1b2b1fd2.png";